import React, { useState, useEffect, useRef } from "react";

import { daysFactor, invisiblestring, statusfarben, statusfarbentext, eskalationsLevel } from "./globalVariables";
import { calculateKachelStatus } from "./pureFunctions";

export default function ProjektstatusListe({
   spalten,
   kacheln,
   heading,
   userObjects,
   abschnittsarray,
   showStatusStufen,
   updateStufenOptionen,
   topic,
}) {
   const [show, setShow] = useState(false);

   

   return (
      <div
         className="projektstatus-l2 m-0 mb-1"
         style={{
            width: "100%",
         }}
      >
         <div style={{ position: "relative" }}>
            <button
               onClick={() => updateStufenOptionen({ key: topic, value: true })}
               className="clean-button "
               title="Bereich minimieren"
               style={{ position: "absolute", right: "10px" }}
            >
               _
            </button>
         </div>
         <h2>
            {abschnittsarray && abschnittsarray.length} {heading}
         </h2>
         {abschnittsarray && (
            <div className="projekt-status-expo projektstatus-l3 text-center">
               <table
                  style={{
                     display: "block",
                     maxHeight: "90vh",
                     overflowY: "auto",
                     overflowX: "hidden",
                  }}
               >
                  <thead style={{ position: "sticky", top: 0 }}>
                     <tr>
                        {spalten.map((spalte, index) => {
                           return (
                              <th
                                 title={spalte.title}
                                 style={
                                    spalte.theme === "dark"
                                       ? { backgroundColor: "#000", color: "#fff", borderBottom: " solid 1px #fff" }
                                       : { backgroundColor: "#fff", color: "#000", borderBottom: " solid 1px #000" }
                                 }
                              >
                                 {spalte.heading}
                              </th>
                           );
                        })}
                        <th title="Objekt" style={{ backgroundColor: "#fff" }}></th>
                     </tr>
                  </thead>
                  <tbody>
                     {abschnittsarray
                        .sort((a, b) => {
                           if (a.vorankundigung && b.vorankundigung) {
                              if (a.vorankundigung < b.vorankundigung) {
                                 return -1;
                              } else {
                                 return 1;
                              }
                           } else if (a.vorankundigung) {
                              return -1;
                           } else {
                              return 1;
                           }
                        })
                        .map((item) => {
                           return (
                              <tr key={"expokey_" + item.objektnr_extern}>
                                 {spalten.map((spalte, index) => {
                                    let countdownDays;

                                    if (spalte.type === "countdown" && item[spalte.id]) {
                                       countdownDays = Math.floor((new Date() - item[spalte.id]) / daysFactor);
                                    }
                                    return (
                                       <td
                                          className="projektstatus-termin"
                                          style={{
                                             background: spalte.theme === "dark" ? "#000" : "#fff",
                                             padding: "0 8px",
                                          }}
                                       >
                                          {spalte.type === "countdown" && (
                                             <div
                                                title={"Datum: " + item[spalte.id].toLocaleString()}
                                                style={
                                                   item[spalte.id]
                                                      ? countdownDays < 0
                                                         ? spalte.style.neg
                                                         : spalte.style.pos
                                                      : spalte.style.undef
                                                }
                                             >
                                                {item[spalte.id] ? countdownDays : "XX"}
                                             </div>
                                          )}
                                          {spalte.type === "colorCountdown" && (
                                             <div
                                                title={"Seit: " + item[spalte.id].toLocaleString()}
                                                style={
                                                   countdownDays < 0
                                                      ? { color: "#000", backgroundColor: "#eee" }
                                                      : {
                                                           textShadow: "0 0 2px #0009",
                                                           backgroundColor: `color-mix(in srgb, #f00 ${100 * Math.min(1, countdownDays / 28)}%, transparent)`,
                                                        }
                                                }
                                             >
                                                {item[spalte.id] ? countdownDays : "XX"}
                                             </div>
                                          )}
                                          {spalte.type === "kachel" && (
                                             <div>
                                                <a
                                                   target="_blank"
                                                   href={
                                                      "/datenblatt?estateid=" +
                                                      item.id +
                                                      "&stufe=" +
                                                      (kacheln[spalte.id] ? kacheln[spalte.id].projektId : "") +
                                                      "&kachel=" +
                                                      spalte.id
                                                   }
                                                   title={spalte.title}
                                                   style={{
                                                      color: statusfarbentext[calculateKachelStatus(item, spalte.id)],
                                                      backgroundColor:
                                                         statusfarben[calculateKachelStatus(item, spalte.id)],
                                                   }}
                                                >
                                                   {item.eskalationsDaten[spalte.id]
                                                      ? Math.round(
                                                           (new Date(item.eskalationsDaten[spalte.id]) - new Date()) /
                                                              daysFactor,
                                                        )
                                                      : invisiblestring}
                                                </a>
                                             </div>
                                          )}
                                          {spalte.type === "projektstufe" && (
                                             <div>
                                                <a
                                                   target="_blank"
                                                   href={"/datenblatt?estateid=" + item.id + "&stufe=" + spalte.id}
                                                   title={spalte.title}
                                                   style={{
                                                      color: statusfarbentext[item.projektstufenstatus[spalte.id]],
                                                      backgroundColor:
                                                         statusfarben[item.projektstufenstatus[spalte.id]],
                                                   }}
                                                >
                                                   {invisiblestring}
                                                </a>
                                             </div>
                                          )}
                                       </td>
                                    );
                                 })}
                                 <td style={{ borderLeft: "solid 1px #000" }}>
                                    <a
                                       target="_blank"
                                       title={item.objektbezeichnung}
                                       className="projektstatus-linkbutton me-1"
                                       style={{ fontWeight: 600, fontSize: "16px" }}
                                       href={"/datenblatt?estateid=" + item.id}
                                    >
                                       {(item.objektbezeichnung
                                          ? item.objektnr_extern + " - " + item.objektbezeichnung.slice(0, -5)
                                          : item.objektnr_extern) + " ↗"}
                                    </a>
                                 </td>
                              </tr>
                           );
                        })}
                  </tbody>
               </table>
            </div>
         )}
      </div>
   );
}
